<!-- 忘记密码 -->
<template>
  <div class="forgetPassword">
    <header>
      <Row type="flex" align="middle" style="height:88px">

        <Col span="9">
        <div style="display:flex;width:100%;align-items:center;justify-content:center;font-size:18px;font-weight: 500;">

          <img src="../../../assets/images/B_user/title.png" alt="" style="width:211px;display:block;">

          <span style="margin:0 10px">|</span>
          <span>企业端</span>
        </div>
        </Col>

        <Col span="6" class="tabs">
        <ul>
          <li style="cursor: pointer;" v-for="(item,index) in tabs" :key="index" @click="go(item.path)">{{item.name}}</li>
        </ul>
        </Col>

        <Col span="9">
        <div>
          <Button type="error" @click="$router.push({name:'Register'})">我要招聘</Button>

          <Poptip style="margin-left:50px;color:#333333;cursor:pointer;" trigger="hover">
            <p>手机端</p>
            <div slot="content" style="display:flex;align-items:center;padding:20px">
              <div style="margin-right:15px">
                <img style="width: 100px;" src="../../../assets/images/img2.png" alt="">
                <p style="text-align:center">小程序</p>
              </div>
              <div style="margin-left:15px">
                <img style="width: 100px;" src="../../../assets/images/img1.png" alt="">
                <p style="text-align:center">公众号</p>
              </div>

            </div>
          </Poptip>

        </div>
        </Col>

      </Row>
    </header>

    <div class="text">
      <p>我的位置：忘记密码</p>

    </div>
    <section>
      <div class="content">
        <Input v-model="mobile" placeholder="请输入手机号" style="width:430px">
        <span slot="prepend">手机号</span>
        </Input>

        <Input v-model="authcode" placeholder="请输入验证码" style="margin:20px 0;width:430px">
        <span slot="prepend">验证码</span>
        <Button slot="append" type="text" @click="get_authcode" :loading="loading" :disabled='disabled' style="color:#009DFF">{{text}}</Button>
        </Input>

        <Input v-model="newPassword" placeholder="请输入新密码" style="margin-bottom:20px;width:430px" type="password" password>
        <span slot="prepend">新密码</span>
        </Input>

        <Input v-model="password_tow" placeholder="再次输入新密码" type="password" password style="width:430px">
        <span slot="prepend">确认密码</span>
        </Input>

        <Button style="margin-top:20px;width:430px;background:#FC4455;color:#fff" @click="ok" :loading="loading_login">提交</Button>

      </div>
    </section>
    <footer>
      <BottomAxis />
    </footer>
  </div>
</template>

<script>
import BottomAxis from "../../../components/Bottom_axis/BottomAxis.vue"
export default {
  data() {
    return {

      tabs: [
        {
          name: '首页',
          path: 'home_page'
        },
        {
          name: '关于我们',
          path: 'about_Us',
        },
        {
          name: '相关资讯',
          path: 'message',
        },
        {
          name: '联系我们',
          path: 'contact_us',
        },

      ],
      loading_login: false,
      mobile: "",
      authcode: "",
      loading: false,
      disabled: false,
      newPassword: '',
      password_tow: '',
      text: '获取验证码',
    }
  },
  components: {
    BottomAxis
  },
  methods: {
    go(path) {
      this.$router.push({ name: path })
    },

    //获取验证码
    get_authcode() {
      //验证手机号格式
      if (/^1[3-9][0-9]{9}$/.test(this.mobile)) {

        //验证手机号是否已注册
        this.loading = true
        this.app('enterpriseOperators', 'checkRegisterMobile', { mobile: this.mobile }).then(res => {
          if (res.data.mobileRegisted) {
            //已被注册可以发送验证码
            this.app('enterpriseOperators', 'sendRegisterCode', { mobile: this.mobile }).then(res => {
              this.loading = false
              this.disabled = true
              this.text = '60'
              let clock = setInterval(() => {
                if (this.text) {
                  this.text--
                } else {
                  this.text = '获取验证码'
                  clearInterval(clock)
                  this.disabled = false
                }
              }, 1000);
            })
          } else {
            this.loading = false
            this.$Modal.warning({
              title: "您还未注册，请先注册再登录！",
              onOk: () => {
                this.$router.push('Register')
              },
              closable: true
            })
          }
        })
      } else {
        this.$Modal.warning({
          title: "手机号码格式不正确"
        })
      }
    },
    ok() {
      //验证手机号及验证码格式
      if (/^1[3-9][0-9]{9}$/.test(this.mobile) && /^[0-9]{6}$/.test(this.authcode)) {
        //验证两个密码一致及是否为空
        if (this.newPassword == this.password_tow && this.newPassword && this.password_tow) {
          //验证密码格式
          
          if (/^.{6,}$/.test(this.newPassword)) {
            // if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/.test(this.newPassword)) {
            this.loading_login = true
            //验证验证码真伪
            // this.app('enterpriseOperators', 'checkCode', {
            //   mobile: this.mobile,
            //   code: this.authcode
            // }).then(res => {

            //   if (res.code == 200) {

            this.app('enterpriseOperators', 'restEmployeePassword',
              {
                mobile: this.mobile,
                newPassword: this.newPassword,
                code: this.authcode
              }).then(re => {
                if (re.code == 200) {
                  this.$Modal.warning({
                    title: "设置成功，返回登录页",
                    onOk: () => {
                      this.$router.push('home_page')
                    },
                    closable: true
                  })
                } else {
                  this.$Modal.warning({
                    title: re.message
                  })
                }
                this.loading_login = false
              })
            //   } else {
            //     this.$Modal.warning({
            //       title: res.message
            //     })
            //     this.loading_login = false
            //   }
            // })
          } else {
            this.$Modal.warning({
              title: "密码格式不正确,请输入至少六位最多十位由数字或字母组成的密码"
            })
          }


        } else {
          this.$Modal.warning({
            title: "密码不一致或为空"
          })
        }

      } else {
        this.$Modal.warning({
          title: "手机号码或验证码格式不正确"
        })
      }
    }
  },
  created() {

  }
}
</script>

<style lang="less" scoped>
@import "./forgetPassword.less";
</style>
